import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { useDropzone } from "react-dropzone";

import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import Loader from "../../common/components/Loader";

class InfoImages extends Component {
    state = {
        uploadAttachmentsHeader: "Add",
        uploadAttachment: [],
        tempAttachment: {},
        uploadError: "",
        fileChanged: false,
        isUploading: false,
        missingRequiredFields: false,
        isInvalidFile: false,
        showConfirmModal: false,
        selectedImage: null,
        isUpdate: null,
        isImage: false,
        numPages: null,
        pageNumber: null,
        isPdf: false
    };

    componentDidMount = () => {
        const { imageList, isRecomentaionView } = this.props;
        if (isRecomentaionView && imageList[0] && imageList[0].url) {
            let ext = imageList[0].name.split(".").pop();
            const isIMage = ["png", "jpg", "ttf", "jpeg", "svg"];
            this.setState({
                attachmentChanged: true,
                tempAttachment: { file: imageList[0] }
            });
            if (isIMage.includes(ext.toLowerCase())) {
                this.setState({ isImage: true });
            } else if (ext === "pdf" || ext === "PDF") {
                this.setState({ isPdf: true });
            }
        }
    };

    isIterable = obj => obj && typeof obj[Symbol.iterator] === "function";

    handleAddAttachment = e => {
        this.setState({ uploadError: "" });
        let files = e.target && e.target.files ? e.target.files : e;
        const maxImageSize = 300 * 1024 * 1024;
        if (this.isIterable(files)) {
            Object.values(files).map(attachment => {
                let ext = attachment.name.split(".").pop();
                const acceptableExt = ["png", "jpg", "ttf", "jpeg", "svg"];
                const safeDocExt = [
                    "pdf",
                    "docx",
                    "xlsx",
                    "pptx",
                    "txt",
                    "rtf",
                    "odt",
                    "csv",
                    "json",
                    "xml",
                    "zip",
                    "stl",
                    "obj",
                    "mtl",
                    "fbx",
                    "dae",
                    "3ds",
                    "iges",
                    "igs",
                    "step",
                    "stp",
                    "glb",
                    "gltf",
                    "dxf"
                ];
                if (!acceptableExt.includes(ext.toLowerCase()) && !safeDocExt.includes(ext.toLowerCase())) {
                    this.setState({
                        uploadError: "Invalid File Type"
                    });
                    return;
                }
                if (acceptableExt.includes(ext.toLowerCase())) {
                    if (attachment.size <= maxImageSize) {
                        this.setState({
                            attachmentChanged: true,
                            tempAttachment: { file: attachment, comments: "" },
                            isImage: true,
                            isPdf: false
                        });
                    } else {
                        this.setState({
                            uploadError: "File is too big. Files with size greater than 300 MB is not allowed."
                        });
                    }
                } else if (["pdf"].includes(ext.toLowerCase())) {
                    if (attachment.size <= maxImageSize) {
                        this.setState({
                            attachmentChanged: true,
                            tempAttachment: { file: attachment, comments: "" },
                            isImage: false,
                            isPdf: true
                        });
                    } else {
                        this.setState({
                            uploadError: "File is too big. Files with size greater than 300 MB is not allowed."
                        });
                    }
                } else {
                    if (attachment.size <= maxImageSize) {
                        this.setState({
                            attachmentChanged: true,
                            tempAttachment: { file: attachment, comments: "" },
                            isImage: false,
                            isPdf: false
                        });
                    } else {
                        this.setState({
                            uploadError: "File is too big. Files with size greater than 300 MB is not allowed."
                        });
                    }
                }
                return null;
            });
        }
    };

    handleDrop = (acceptedFiles, fileRejections) => {
        if (fileRejections && fileRejections.length) {
            if (fileRejections[0].errors.some(error => error.code === "too-many-files")) {
                this.setState({
                    uploadError: "Please upload only one file at a time."
                });
                return;
            }

            this.setState({
                uploadError: fileRejections[0].errors[0].message || "File upload error. Please check your file."
            });
            return;
        }

        if (acceptedFiles && acceptedFiles.length === 1) {
            const fakeEvent = { target: { files: [acceptedFiles[0]] } };
            this.handleAddAttachment(fakeEvent);
            // this.setState({ uploadError: "" });
        }
    };

    deleteAttachment = async () => {
        await this.props.deleteImage(this.state.selectedImage);
        this.setState({
            showConfirmModal: false,
            tempAttachment: {},
            isUploading: false,
            missingRequiredFields: false,
            isUpdate: null
        });
    };

    handleDeleteAttachment = async id => {
        if (this.props.isRecomentaionView) {
            await this.props.deleteImageRecomention();
            this.setState({ tempAttachment: {}, isUpdate: null });
        } else {
            this.setState({
                showConfirmModal: true,
                selectedImage: id
            });
        }
    };

    handleUpdateComment = async () => {
        this.setState({ isUploading: true });
        const { tempAttachment } = this.state;
        this.props.handleAddImage(tempAttachment);
        await this.setState({
            tempAttachment: {},
            isUploading: false,
            missingRequiredFields: false
        });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to delete this Image?"}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.deleteAttachment}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    addImage = async () => {
        const { handleAddImage, isRecomentaionView } = this.props;
        this.setState({ isUploading: true });
        const { tempAttachment, uploadAttachment } = this.state;
        if (!tempAttachment.file) {
            this.setState({
                isUploading: false,
                missingRequiredFields: true,
                uploadError: "*Document Required"
            });
            return false;
        }
        if (isRecomentaionView) {
            handleAddImage(tempAttachment);
        } else {
            await this.props.uploadImages(tempAttachment);
            await this.setState({
                uploadAttachment: [...uploadAttachment, tempAttachment],
                tempAttachment: {},
                isUploading: false,
                missingRequiredFields: false
            });
        }
    };

    handleDescription = e => {
        const { tempAttachment } = this.state;
        this.setState({
            tempAttachment: {
                ...tempAttachment,
                comments: e.target.value
            }
        });
    };

    render() {
        const { tempAttachment, isUploading, missingRequiredFields, uploadError, isUpdate } = this.state;
        const { onCancel } = this.props;

        return (
            <React.Fragment>
                <div id="modalId" className="modal modal-region modal-add-img report-modal" style={{ display: "block" }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" onClick={onCancel}>
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body region-otr">
                                <div className="otr-add-img">
                                    <div className="add-imges col-md-12 p-0">
                                        <h3>Add Document</h3>

                                        <div className="innr-img">
                                            <DropFileZone
                                                onDrop={this.handleDrop}
                                                className={`${
                                                    missingRequiredFields && !this.props.isRecomentaionView && !tempAttachment.file
                                                        ? "error-border"
                                                        : ""
                                                } drag-otr cursor-pointer`}
                                            >
                                                {!_.isEmpty(tempAttachment) && tempAttachment.file ? (
                                                    <>
                                                        {this.state.isImage ? (
                                                            <img
                                                                src={
                                                                    tempAttachment.file.url
                                                                        ? tempAttachment.file.url
                                                                        : URL.createObjectURL(tempAttachment.file)
                                                                }
                                                                alt=""
                                                            />
                                                        ) : this.state.isPdf ? (
                                                            <img src="/img/pdfIcon.jpeg" alt="" />
                                                        ) : (
                                                            <img src="/img/docIcon.webp" alt="" />
                                                        )}
                                                        <p>{tempAttachment.file && tempAttachment.file.name}</p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-cloud-upload-alt"></i>
                                                        <p>Click or drag file here to upload</p>
                                                    </>
                                                )}
                                            </DropFileZone>

                                            <div className="text-center">
                                                <small className="text-danger">{uploadError}</small>
                                            </div>

                                            <div className="upld-otr d-flex">
                                                {!isUploading ? (
                                                    !isUpdate ? (
                                                        <label className="custom-file-uploadd cursor-pointer" onClick={() => this.addImage()}>
                                                            Add Document
                                                        </label>
                                                    ) : (
                                                        <>
                                                            <label
                                                                className="btn btn-light mr-2"
                                                                onClick={
                                                                    this.props.isRecomentaionView
                                                                        ? () => onCancel()
                                                                        : () =>
                                                                              this.setState({
                                                                                  tempAttachment: {},
                                                                                  isUpdate: null
                                                                              })
                                                                }
                                                            >
                                                                Cancel
                                                            </label>
                                                            <label
                                                                className="custom-file-uploadd cursor-pointer"
                                                                onClick={() => this.handleUpdateComment()}
                                                            >
                                                                Update Document
                                                            </label>
                                                        </>
                                                    )
                                                ) : (
                                                    <label
                                                        className="custom-file-uploadd cursor-pointer"
                                                        style={{ position: "relative" }}
                                                        onClick={this.props.isRecomentaionView ? () => onCancel() : () => this.addImage()}
                                                    >
                                                        <Loader />
                                                    </label>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderConfirmationModal()}
            </React.Fragment>
        );
    }
}

function DropFileZone({ onDrop, children, className }) {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles, fileRejections) => onDrop(acceptedFiles, fileRejections),
        multiple: false
    });
    return (
        <div
            {...getRootProps()}
            className={`${className ? className : ""} dropzone-area${isDragActive ? " drag-active" : ""}`}
            style={{
                transition: "border 0.2s",
                border: "2px dashed #ccc",
                borderRadius: "8px",
                padding: "16px",
                cursor: "pointer",
                outline: isDragActive ? "2px solid #2296f3" : ""
            }}
        >
            <input {...getInputProps()} />
            {children}
        </div>
    );
}

export default withRouter(InfoImages);
